module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<section class="content-header">\r\n    <h1>\r\n        CARTOGRAFÍA\r\n\r\n    </h1>\r\n</section>\r\n\r\n\r\n\r\n<section class="content">\r\n    <div class="col-md-2 col-xs-4 form-group titleField">\r\n        <label>Seleccionar:</label>\r\n    </div>\r\n    <div class="col-md-3 col-xs-8 form-group inputField">\r\n        <select id="planos_tipo" class="form-control">\r\n            ';
  if(instance  == 17){  
__p+='\r\n                <option value="" selected >----</option>\r\n                <option value="urbana">PLANO URBANA/RÚSTICA</option> \r\n                <option value="caminos">PLANO CAMINOS</option> \r\n            ';
  }else if(instance  == 8){  
__p+='\r\n                <option value="" selected >----</option>\r\n                <option value="urbana">PLANO URBANA</option> \r\n                <option value="rustica">PLANO RÚSTICA</option> \r\n             ';
  }else if(instance  == 20){  
__p+='\r\n                <option value="" selected >----</option>\r\n                <option value="construcciones">1.05 Construcciones</option> \r\n                <option value="terrenosrusticos">1.02-1.04 Terrenos rusticos</option> \r\n                <option value="parquesyjardines">1.07 Parques y jardines</option> \r\n                <option value="terrenospps">9.01 Terrenos PPS (1)</option> \r\n                <option value="terrenosurbanosconconstrucciones">1.03 Terrenos urbanos con construcciones</option> \r\n                <option value="intalacionesdeportivaslibre">1.11 Intalaciones deportivas y de recreo al aire libre</option> \r\n                <option value="urbanizacionexterior">1.08 Urbanizacion exterior</option> \r\n                <option value="caminosrurales">1.09 Caminos Rurales</option>  \r\n            ';
  }else{  
__p+='\r\n                <option value="" selected >----</option>\r\n                <option value="urbana">PLANO URBANO</option>\r\n                <option value="rustica">PLANO RUSTICO CON TITULARIDAD</option>\r\n                <option value="rustica_notitular">PLANO RUSTICO SIN TITULARIDAD</option>\r\n            \r\n            ';
  }  
__p+='\r\n               \r\n            </select>\r\n    </div>\r\n    <div class="magnify">\r\n        <div class="large"></div>\r\n\r\n\r\n\r\n        ';

                   
                    var http = new XMLHttpRequest();
                    http.open('HEAD', web, false);
                    http.send();
                    if (http.status==404)
                    {
                        web = "files/planos/fallo.jpg";
                        this.lupa = 0;
                    }

                    if (lupa == 1)   
                        print('<img  class="small" src="'+ web + '" width="100%" height="100%"/>');
                    else
                        print('<center><h2>No existe imagen de plano</h2> </br></br><img   src="'+ web + '"  max-width="600px" max-height="600px"  /></center>');
                 
                
__p+='\r\n\r\n    </div>\r\n    <!--magnify-->\r\n\r\n\r\n\r\n    <!-- Lets load up prefixfree to handle CSS3 vendor prefixes -->\r\n    <script src="https://thecodeplayer.com/uploads/js/prefixfree.js" type="text/javascript"></script>\r\n    <!-- You can download it from http://leaverou.github.com/prefixfree/ -->\r\n\r\n    <!-- Time for jquery action -->\r\n    <script src="https://thecodeplayer.com/uploads/js/jquery-1.7.1.min.js" type="text/javascript"></script>\r\n\r\n    ';

       
       $(document).ready(function(){

var native_width = 0;
var native_height = 0;

//Now the mousemove function
$(".magnify").mousemove(function(e){
    //When the user hovers on the image, the script will first calculate
    //the native dimensions if they don't exist. Only after the native dimensions
    //are available, the script will show the zoomed version.
    if(!native_width && !native_height)
    {
        //This will create a new image object with the same image as that in .small
        //We cannot directly get the dimensions from .small because of the 
        //width specified to 200px in the html. To get the actual dimensions we have
        //created this image object.
        var image_object = new Image();
        image_object.src = $(".small").attr("src");
        
        //This code is wrapped in the .load function which is important.
        //width and height of the object would return 0 if accessed before 
        //the image gets loaded.
        native_width = image_object.width;
        native_height = image_object.height;
    }
    else
    {
        //x/y coordinates of the mouse
        //This is the position of .magnify with respect to the document.
        var magnify_offset = $(this).offset();
        //We will deduct the positions of .magnify from the mouse positions with
        //respect to the document to get the mouse positions with respect to the 
        //container(.magnify)
        var mx = e.pageX - magnify_offset.left;
        var my = e.pageY - magnify_offset.top;
        
        //Finally the code to fade out the glass if the mouse is outside the container
        if(mx < $(this).width() && my < $(this).height() && mx > 0 && my > 0)
        {
            $(".large").fadeIn(100);
        }
        else
        {
            $(".large").fadeOut(100);
        }
        if($(".large").is(":visible"))
        {
            //The background position of .large will be changed according to the position
            //of the mouse over the .small image. So we will get the ratio of the pixel
            //under the mouse pointer with respect to the image and use that to position the 
            //large image inside the magnifying glass
            var rx = Math.round(mx/$(".small").width()*native_width - $(".large").width()/2)*-1;
            var ry = Math.round(my/$(".small").height()*native_height - $(".large").height()/2)*-1;
            var bgp = rx + "px " + ry + "px";
            
            //Time to move the magnifying glass with the mouse
            var px = mx - $(".large").width()/2;
            var py = my - $(".large").height()/2;
            //Now the glass moves with the mouse
            //The logic is to deduct half of the glass's width and height from the 
            //mouse coordinates to place it with its center at the mouse coordinates
            
            //If you hover on the image now, you should see the magnifying glass in action
            var fondo = "url('"+ web +"') no-repeat";
            $(".large").css({left: px, top: py, background: fondo, backgroundPosition: bgp});
        }
    }
})
})
       
__p+='\r\n\r\n\r\n\r\n</section>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/planos/planos.ejs
// module id = 443
// module chunks = 0